import Swal from 'sweetalert2'

export default {
  error(message: string) {
    Swal.fire({
      icon: 'error',
      title: message,
      showConfirmButton: false,
      showCloseButton: true
    })
  },
  success(message: string) {
    Swal.fire({
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: 2500
    })
  },
  info(message: string) {
    Swal.fire({
      icon: 'info',
      title: message,
      showConfirmButton: false,
      showCloseButton: true
    })
  },
  warn(message: string) {
    Swal.fire({
      icon: 'warning',
      title: message,
      showConfirmButton: false,
      showCloseButton: true
    })
  }
}
